import { render, staticRenderFns } from "./previewinfo.vue?vue&type=template&id=82332312"
import script from "./previewinfo.vue?vue&type=script&lang=js"
export * from "./previewinfo.vue?vue&type=script&lang=js"
import style0 from "./previewinfo.vue?vue&type=style&index=0&id=82332312&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.29_css-loader@6.11.0_webpack@5.92.0__lodash@4.17.21__w6vssq2jddkf54swt2owhyy3ou/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports